// extracted by mini-css-extract-plugin
export default {"container":"QL-z","dimension":"RL-z","dimensionLabels":"SL-z"};